import React from "react";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import { docs } from "./specs/openapi";

const App = () => {
  return (
    <SwaggerUI
      spec={docs}
      defaultModelsExpandDepth={-1}
      supportedSubmitMethods={[]}
      tryItOutEnabled={false}
      persistAuthorization={false}
    />
  );
};

export default App;
